/** Matches prod Identity Platform password policy (enforced server-side). */
export const MIN_PASSWORD_LENGTH = 12;
